import { Grid2 as Grid, Stack, Typography } from "@mui/material"
import AppWidget from "minimals-template/pages/sections/@dashboard/general/app/AppWidget"
import { statsForRegister } from "routes/asset-register/plugins/asset-mapping/controller/stats-for-register"
import { useTarget } from "lib/@hooks/use-target"
import { useSearchParam } from "lib/@hooks/use-search-param"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { refreshId } from "lib/graphql/api"

export function MappingWidgets() {
    const target = useTarget()
    const {
        totalTypes = 0,
        mapped,
        doNotMap,
        notMapped,
        mappedAssets,
        notMappedAssets,
        doNotMapAssets,
    } = statsForRegister.useResults(refreshId(target._id)) ?? {}
    const totalAssets = mappedAssets + notMappedAssets + doNotMapAssets
    const [, setFilter] = useSearchParam("filter")
    const { isManualMapTab } = useBoundContext()

    return totalTypes < 1 || totalAssets < 1 ? null : (
        <Grid container spacing={1} sx={{ width: 1 }} alignItems="stretch" width="100%">
            <Grid size={{ xs: 12, md: 4 }}>
                <AppWidget
                    onClick={() => setFilter("not mapped")}
                    data-cy="mapping-not-mapped"
                    component="button"
                    sx={{ cursor: "pointer", mt: 0 }}
                    title="To Do"
                    color="primary"
                    total={<WidgetSecondaryInfo types={notMapped} assets={notMappedAssets} />}
                    chartData={{
                        series: [((notMapped / totalTypes) * 100).toFixed(1) || 0],
                    }}
                />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <AppWidget
                    onClick={() => setFilter("mapped")}
                    data-cy="mapping-mapped"
                    component="button"
                    sx={{ cursor: "pointer", mt: 0 }}
                    title={isManualMapTab ? "Mapped" : "Done"}
                    color="success"
                    total={<WidgetSecondaryInfo types={mapped} assets={mappedAssets} />}
                    chartData={{
                        series: [((mapped / totalTypes) * 100).toFixed(1) || 0],
                    }}
                />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <AppWidget
                    data-cy="mapping-excluded"
                    component="button"
                    onClick={() => setFilter("do not map")}
                    sx={{ cursor: "pointer", mt: 0 }}
                    title="Excluded"
                    color="error"
                    total={<WidgetSecondaryInfo types={doNotMap} assets={doNotMapAssets} />}
                    chartData={{
                        series: [((doNotMap / totalTypes) * 100).toFixed(1) || 0],
                    }}
                />
            </Grid>
        </Grid>
    )
}

export function WidgetSecondaryInfo({ types, assets }) {
    return (
        <Stack>
            <Typography variant="h5" noWrap>
                {types}
                <Typography
                    variant="caption"
                    color="text.secondary"
                    component="span"
                >{` (${"Asset Type".pluralize(types)})`}</Typography>
            </Typography>

            <Typography variant="caption" color="text.secondary">
                {assets.toLocaleString()} {"Asset".pluralize(assets)}
            </Typography>
        </Stack>
    )
}
